module.exports = __webpack_public_path__ + "static/media/flowers_bg1x.ffca035c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flowers_bg1x.png
// module id = 155
// module chunks = 0